<template>
  <ul>
    <template v-for="item in items">
      <component
        :is="resolveNavItemComponent(item)"
        v-if="checkRoles(item)"
        :key="item.header || item.title"
        :item="item"
    /></template>
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@core/layouts/utils";
import { provide, ref } from "@vue/composition-api";
import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";
import VerticalNavMenuGroup from "../vertical-nav-menu-group/VerticalNavMenuGroup.vue";

export default {
  watch: {
    $store(val) {
      console.log("TESTTT", val);
    },
  },
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup() {
    provide("openGroups", ref([]));

    return {
      resolveNavItemComponent,
    };
  },
  methods: {
    checkRoles(item) {
      if (
        item.route == "DevicesIndex" ||
        item.route == "CattleIndex" ||
        item.route == "SettingsIndex"
      ) {
        if (this.$store.state.user && this.$store.state.user.userType == 1)
          return true;
        else return false;
      } else return true;
    },
  },
};
</script>
